var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 12 18",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.499 0-.12.41v11.9l.12.12 5.497-3.264z",
    fill: "#7160ee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.497 0-5.497 9.166 5.497 3.265z",
    fill: "#a096ed"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5.501 13.475-.067.082v4.24l.067.198 5.5-7.784z",
    fill: "#7160ee"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m5.497 17.995v-4.52l-5.497-3.265 5.497 7.784z",
    fill: "#a096ed"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m5.502 12.432 5.497-3.265-5.497-2.51z",
    fill: "#3c2bb9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m0 9.167 5.497 3.265v-5.776z",
    fill: "#7160ee"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eth.613e6b279f41521d7b7491878478abb4.svg";